<template>
  <div ref="wrapperElement" :class="[$style.wrapper, {[$style.wrapperAnimated]: isScrolled}]">
    <div :class="$style.content">
      <lv-heading
        level="2"
        tag="h2"
        version2
        :class="$style.title"
      >
        {{ $awt('aw.cms.ok_auchan.title') }}
      </lv-heading>
      <p :class="$style.text" v-html="$awt('aw.cms.ok_auchan.text')" />
      <div :class="$style.links">
        <lv-button
          v-for="(linkData, i) in linkDatas"
          :key="linkData.key"
          :class="$style.link"
          styling="reset"
          v-bind="linkData.hyperlinkBind"
          v-on="bannerEvtListeners[i]"
        >
          <img v-bind="linkData.imgBind" loading="lazy" :class="$style.badge">
        </lv-button>
      </div>
    </div>
    <div :class="$style.fruitsWrapper">
      <div :class="$style.fruits">
        <img
          v-aw-lazy-media
          alt=""
          loading="lazy"
          :src="$addWebpPostfixIfSupported({ url: orange, webpUrl: orangeWebp })"
          :class="$style.orange"
        >
        <img
          v-aw-lazy-media
          alt=""
          loading="lazy"
          :src="$addWebpPostfixIfSupported({ url: tangerine, webpUrl: tangerineWebp })"
          :class="$style.tangerine"
        >
        <img
          v-aw-lazy-media
          alt=""
          loading="lazy"
          :src="$addWebpPostfixIfSupported({ url: kiwi, webpUrl: kiwiWebp })"
          :class="$style.kiwi"
        >

        <img
          v-aw-lazy-media
          alt=""
          loading="lazy"
          :src="$addWebpPostfixIfSupported({ url: ananas, webpUrl: ananasWebp })"
          :class="$style.ananas"
        >
        <img
          v-aw-lazy-media
          alt=""
          loading="lazy"
          :src="$addWebpPostfixIfSupported({ url: phone1, webpUrl: phone1Webp })"
          :class="$style.phone1"
        >
        <img
          v-aw-lazy-media
          alt=""
          loading="lazy"
          :src="$addWebpPostfixIfSupported({ url: strawberry, webpUrl: strawberryWebp })"
          :class="$style.strawberry"
        >

        <img
          v-aw-lazy-media
          alt=""
          loading="lazy"
          :src="$addWebpPostfixIfSupported({ url: phone2, webpUrl: phone2Webp })"
          :class="$style.phone2"
        >

        <img
          v-aw-lazy-media
          alt=""
          loading="lazy"
          :src="$addWebpPostfixIfSupported({ url: phone3, webpUrl: phone3Webp })"
          :class="$style.phone3"
        >

        <div :class="$style.greenShade">
          <svg
            width="374"
            height="143"
            viewBox="0 0 374 143"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <ellipse
              cx="187"
              cy="71.5"
              rx="187"
              ry="71.5"
              fill="#16B9A0"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { computed, onMounted, onUnmounted, ref } from 'vue';
  import { useNuxtApp } from 'nuxt/app';

  import ananas from '~~/common/assets/images/okAuchanMobileApp/ananas.png';
  import ananasWebp from '~~/common/assets/images/okAuchanMobileApp/ananas.png.webp';

  import kiwi from '~~/common/assets/images/okAuchanMobileApp/kiwi.png';
  import kiwiWebp from '~~/common/assets/images/okAuchanMobileApp/kiwi.png.webp';

  import orange from '~~/common/assets/images/okAuchanMobileApp/orange.png';
  import orangeWebp from '~~/common/assets/images/okAuchanMobileApp/orange.png.webp';

  import phone1 from '~~/common/assets/images/okAuchanMobileApp/phone1.png';
  import phone1Webp from '~~/common/assets/images/okAuchanMobileApp/phone1.png.webp';

  import phone2 from '~~/common/assets/images/okAuchanMobileApp/phone2.png';
  import phone2Webp from '~~/common/assets/images/okAuchanMobileApp/phone2.png.webp';

  import phone3 from '~~/common/assets/images/okAuchanMobileApp/phone3.png';
  import phone3Webp from '~~/common/assets/images/okAuchanMobileApp/phone3.png.webp';

  import strawberry from '~~/common/assets/images/okAuchanMobileApp/strawberry.png';
  import strawberryWebp from '~~/common/assets/images/okAuchanMobileApp/strawberry.png.webp';

  import tangerine from '~~/common/assets/images/okAuchanMobileApp/tangerine.png';
  import tangerineWebp from '~~/common/assets/images/okAuchanMobileApp/tangerine.png.webp';

  import appStoreBadge from '~~/common/assets/images/app_store_badge.svg';
  import googlePlayBadge from '~~/common/assets/images/google_play_badge.svg';
  import analyticsBannerInteractionMixin from '~~/common/mixins/analyticsBannerInteractionMixin';
  import { createThrottledSendBannerViewInteraction, genBannerInteractionClickEventHandlers } from '~~/common/utils/bannerInteractionAnalytics';
  import { LvButton, LvHeading } from '~~/common/components/loginet-vue-shop/index';
  import { useUserInterfaceStore } from '~~/common/stores/userInterface.js';

  defineOptions({
    inheritAttrs: false,
  });

  const props = defineProps(analyticsBannerInteractionMixin.props);
  const isScrolled = ref(false);
  let scrollTimer = null;
  const wrapperElement = ref(null);

  const {
    $awt,
    $hyperlinkComputeBindFromUrl,
  } = useNuxtApp();

  const linkDatas = computed(() => {
    return [
      {
        url: $awt('aw.cms.ok_auchan.android_link'),
        src: googlePlayBadge,
        applicationType: 'Google Play',
        alt: $awt('aw.common.mobile_app_stores.play_store'),
      },
      {
        url: $awt('aw.cms.ok_auchan.ios_link'),
        src: appStoreBadge,
        applicationType: 'App Store',
        alt: $awt('aw.common.mobile_app_stores.app_store'),
      },
    ].map(({
      url,
      src,
      applicationType,
      alt,
    }) => {
      return {
        key: url,
        imgBind: {
          src,
          alt,
        },
        hyperlinkBind: {
          ...$hyperlinkComputeBindFromUrl(url),
          'aria-label': alt,
        },
        applicationType,
      };
    });
  });
  const bannerEvtListeners = computed(() => {
    const titlePrefix = $awt('aw.cms.ok_auchan.title');
    return linkDatas.value.map(linkData => genBannerInteractionClickEventHandlers(props, { title: `${titlePrefix} ${linkData.applicationType}` }));
  });

  const screenRange = computed(() => {
    return useUserInterfaceStore().mediaQueries;
  });

  onMounted(() => {
    createThrottledSendBannerViewInteraction()(props);
    scrollListener();
    window.addEventListener('scroll', scrollListener, true);
  });

  onUnmounted(() => {
    window.removeEventListener('scroll', scrollListener, true);
    clearTimeout(scrollTimer);
  });

  function scrollListener () {
    clearTimeout(scrollTimer);
    if (screenRange.value['tablet-max']) {
      scrollTimer = setTimeout(() => {
        const component = wrapperElement.value;
        const rect = component.getBoundingClientRect();
        const screenMiddle = window.innerHeight / 2;
        isScrolled.value = rect.top <= screenMiddle && rect.bottom >= screenMiddle;
      }, 32);
    }
  }
</script>

<style module lang="scss" rel="stylesheet/scss">
$okauchan-banner-animation: cubic-bezier(0.4, 0, 0.2, 1);
$okauchan-banner-animation-duration: 0.6s;

.wrapper {
  font-family: $secondary-font;
  position: relative;
  display: grid;
  overflow: hidden;
  width: 100%;
  min-height: 436px;
  border-radius: 24px;
  background: linear-gradient(90deg, #{$color-viridis} 50%, #{$color-topaz} 100%);

  @include mobile(max) {
    text-align: center;
  }

  @include tablet(min) {
    max-width: 100%;
    min-height: 248px;
    grid-template-columns: 1fr 1fr;
  }

  .fruits {
    position: absolute;
    left: 50%;
    overflow: hidden;
    width: 448px;
    height: 350px;
    transform: translateX(-50%);
    transform-origin: center;

    &Wrapper {
      position: relative;
      width: 100%;
      height: 350px;
    }

    @include tablet(min) {
      left: 0;
      width: 100%;
      height: 100%;
      transform: unset;
      transform-origin: unset;

      &Wrapper {
        height: 100%;
      }
    }

    @include tablet(only) {
      left: -41px;
      width: calc(100% + 41px);
    }

    @include desktop-small(only) {
      left: -12px;
      width: calc(100% + 12px);
    }

    @include desktop-medium(only) {
      left: 0;
      width: 100%;
    }

    @include sidebar-desktop-medium-large(min) {
      left: -12px;
      width: calc(100% + 12px);
    }

    @include desktop-large(min) {
      left: -48px;
      width: calc(100% + 48px);
    }

    .ananas,
    .kiwi,
    .orange,
    .phone1,
    .phone2,
    .phone3,
    .strawberry,
    .tangerine,
    .greenShade {
      position: absolute;
      left: 0;
      transition: all $okauchan-banner-animation-duration $okauchan-banner-animation;
    }

    .phone1,
    .phone2,
    .phone3 {
      width: 96.16px;
      height: 197.41px;

      @include sidebar-desktop-medium-large(min) {
        width: 114.13px;
        height: 234.32px;
      }
    }

    .ananas {

      top: -10.16px;
      left: 2.97px;

      width: 196.6px;
      height: 294.25px;
      transform: scale(1, -1) rotate(30deg);
      object-fit: cover;

      @include tablet(only) {
        top: -18.36px;
        left: 12.12px;
      }

      @include desktop-small(only) {
        top: -28.36px;
        left: 58.12px;
      }

      @include sidebar-desktop-medium-large(min) {
        top: 7.87px; //--> -97.48
        left: 129.83px; //--> 22.98
        width: 233.35px; //--> 355.22  -- 1,5222
        height: 349.26px; //-->531.67 --  1,5222
      }
    }

    .kiwi {
      top: 44.92px;

      left: 45.57px;

      width: 175.25px;
      height: 263.71px;
      transform: rotate(82.76deg);
      object-fit: cover;

      @include tablet(only) {
        top: 29.92px;
        left: 51.57px;
      }

      @include desktop-small(only) {
        top: 18.92px;
        left: 93.57px;
      }

      @include sidebar-desktop-medium-large(min) {
        top: 72.5px; //--> -106.61
        left: 176.5px; //--> 202.73
        width: 208px; //--> 249.43 -- 1.1991
        height: 313px; //--> 374.26 -- 1.1957
        transform: rotate(90deg);
      }
    }

    .orange {
      top: -30.42px;
      left: 272.87px;

      width: 178.01px;
      height: 263.78px;
      transform: rotate(22.52deg);

      @include tablet(only) {
        top: -42.42px;
        left: 280.87px;
      }

      @include desktop-small(only) {
        top: -59.42px;
        left: 318.87px;
      }

      @include sidebar-desktop-medium-large(min) {
        top: -37.16px; //--> -148.59
        left: 438.58px; //--> 414.37
        width: 211.29px; //--> 355.22 -- 1.6812
        height: 313.1px; //--> 526.37 -- 1.6812
      }
    }

    .phone1 {
      top: 119.98px;
      left: 110.94px;

      @include tablet(only) {
        top: 109.98px;
        left: 119.94px;
      }

      @include desktop-small(only) {
        top: 93.98px;
        left: 161.94px;
      }

      @include sidebar-desktop-medium-large(min) {
        top: 146.24px;
        left: 249.48px;
      }
    }

    .phone2 {
      top: 84.93px;
      left: 177.68px;

      @include tablet(only) {
        top: 74.93px;
        left: 186.68px;
      }

      @include desktop-small(only) {
        top: 58.93px;
        left: 228.68px;
      }

      @include sidebar-desktop-medium-large(min) {
        top: 104.64px;
        left: 328.68px;
      }
    }

    .phone3 {
      top: 100.09px;
      left: 246.26px;

      @include tablet(only) {
        top: 90.09px;
        left: 255.26px;
      }

      @include desktop-small(only) {
        top: 74.09px;
        left: 297.26px;
      }

      @include sidebar-desktop-medium-large(min) {
        top: 122.64px;
        left: 410.09px;
      }
    }

    .strawberry {
      top: 93.23px;

      left: 138.5px;
      width: 74.72px;
      height: 63.62px;
      transform: scaleY(-1) rotate(-49.36deg);

      @include tablet(only) {
        top: 82.82px;
        left: 150.27px;
      }

      @include desktop-small(only) {
        top: 74.82px;
        left: 193.27px;
      }

      @include sidebar-desktop-medium-large(min) {
        top: 114px;
        left: 283px;
        width: 88.7px;
        height: 75.51px;
      }
    }

    .tangerine {
      top: 25.96px;
      left: 133.64px;

      width: 225.79px;
      height: 161.76px;
      transform: scaleY(-1) rotate(120deg);

      @include tablet(only) {
        top: 15.96px;
        left: 142.64px;
      }

      @include desktop-small(only) {
        top: -0.04px;
        left: 178.64px;
      }

      @include sidebar-desktop-medium-large(min) {
        top: 37.05px; //--> 60.76
        left: 275.14px; //--> 74.64
        width: 268px; //--> 347.25 -- 1.2957
        height: 192px; //--> 247.97 -- 1,2915
      }
    }

    .greenShade {
      top: 273px;
      left: 9px;
      width: 374px;
      height: 143px;
      opacity: 0.5;
      filter: blur(172.13px);

      @include tablet(only) {
        top: 263px;
      }

      @include desktop-small(only) {
        top: 247px;
        left: 51px;
      }

      @include sidebar-desktop-medium-large(min) {
        top: 208px;
        left: 67px;
        width: 533px;
        height: 166px;
      }
    }
  }

  .content {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    max-width: 328px;
    margin: 0 auto;
    padding: 40px 16px;
    color: $color-white;

    @include tablet(min) {
      max-width: unset;
      margin: 0 -41px 0 0;
      padding: 40px 0 40px 40px;
    }

    @include desktop-small(only) {
      margin: 0 -12px 0 0;
    }

    @include desktop-medium(only) {
      margin: 0;
    }

    @include desktop-large(only) {
      margin: 0 -48px 0 0;
    }

    .title {
      margin-bottom: 16px;
      text-align: center;

      @include tablet(min) {
        text-align: left;
      }
    }

    .text {
      @include font($font-weight-regular-v2, 12px, 16px);
      margin-bottom: 40px;

      @include tablet(min) {
        @include font($font-weight-normal-v2, 14px, 20px);
      }
    }

    .links {
      display: grid;
      grid-template-columns: 107px 95px;
      gap: 24px;
      justify-content: center;

      @include mobile(min) {
        grid-template-columns: 135px 117px;
      }

      @include tablet(min) {
        justify-content: flex-start;
      }

      .link {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: max-content;
      }

      .badge {
        height: 32px;
        @include mobile(min) {
          height: 40px;
        }
      }
    }
  }

  &:hover,
  &Animated {
    .fruits {
      .ananas {

        top: -53.36px;
        left: -22.88px;
        width: 299.27px;
        height: 447.93px;
        transform: scale(1, -1) rotate(45deg);


        @include tablet(only) {
          top: -39.36px;
          left: 17.12px;
        }

        @include desktop-small(only) {
          top: -47.36px;
          left: 3.12px;
        }


        @include sidebar-desktop-medium-large(min) {
          top: -97.48px;
          left: 22.98px;
          width: 355.22px;
          height: 531.67px;
        }
      }

      .kiwi {
        top: -90.08px;

        left: 88.57px;

        width: 210.14px;
        height: 315.32px;
        transform: rotate(52.76deg);

        @include tablet(only) {
          top: -68.08px;
          left: 88.57px;
        }

        @include desktop-small(only) {
          top: -84.08px;
          left: 130.57px;
        }

        @include sidebar-desktop-medium-large(min) {
          top: -106.61px;
          left: 202.73px;

          width: 249.43px;
          height: 374.26px;
          transform: rotate(60deg);
        }
      }

      .orange {
        top: -40.42px;
        left: 186.87px;

        width: 299.27px;
        height: 443.47px;
        transform: rotate(1.9deg);

        @include tablet(only) {
          top: -50.42px;
          left: 186.87px;
        }

        @include desktop-small(only) {
          top: -50.42px;
          left: 268.87px;
        }

        @include sidebar-desktop-medium-large(min) {
          top: -148.59px;
          left: 414.37px;
          width: 355.22px;
          height: 526.37px;
        }
      }

      .phone1 {
        top: 99.76px;
        transform: rotate(10deg);

        @include tablet(only) {
          top: 89.76px;
        }

        @include desktop-small(only) {
          top: 73.76px;
        }

        @include sidebar-desktop-medium-large(min) {
          top: 122.24px;
        }
      }

      .phone2 {
        transform: rotate(10deg);
      }

      .phone3 {
        top: 66.39px;
        transform: rotate(10deg);

        @include tablet(only) {
          top: 56.39px;
        }

        @include desktop-small(only) {
          top: 40.39px;
        }

        @include sidebar-desktop-medium-large(min) {
          top: 82.64px;
        }
      }

      .strawberry {
        top: 77.31px;

        left: 149.5px;
        width: 82.7px;
        height: 70.41px;
        transform: scaleY(-1) rotate(1.76deg);

        @include tablet(only) {
          top: 67.31px;
          left: 160.5px;
        }

        @include desktop-small(only) {
          top: 59.31px;
          left: 199.5px;
        }

        @include sidebar-desktop-medium-large(min) {
          top: 95.59px;
          left: 294.06px;
          width: 98.17px;
          height: 83.57px;
        }
      }

      .tangerine {
        top: 103.96px;

        left: 44.64px;

        width: 292.56px;
        height: 208.91px;
        transform: scaleY(-1) rotate(163.78deg);

        @include tablet(only) {
          top: 93.96px;
          left: 44.64px;
        }

        @include desktop-small(only) {
          top: 93.96px;
          left: 78.64px;
        }

        @include sidebar-desktop-medium-large(min) {
          top: 60.76px;
          left: 74.64px;
          width: 347.25px;
          height: 247.97px;
        }
      }
    }
  }
}
</style>
